import { client, gql } from 'data-provider';
import { IAccount, IAccountLogInfo } from 'interfaces';
import { EUserType, ETransactionType } from 'pages/accounts/logs.type';

interface IGetAllAccountParams {
  query?: string;
  userType?: EUserType;
  startDate?: string;
  endDate?: string;
}

export const getAccounts = async (searchParams?: IGetAllAccountParams) => {
  const graphqlQuery = gql`
    query ($query: String, $userType: AllowedUserType, $startDate: String, $endDate: String) {
      accountDashboard(query: $query, userType: $userType, startDate: $startDate, endDate: $endDate) {
        data {
          id
          name
          type
          totalPayable
          totalReceivable
        }
        keywords
      }
    }
  `;

  const data = await client.request(graphqlQuery, searchParams);
  return data.accountDashboard as { data: IAccount[]; keywords: string };
};

interface IAccountLogQuery {
  accountLogsId: string;
  startDate: string;
  endDate: string;
  userType: EUserType;
  query?: string;
  transactionType?: ETransactionType;
}

export const getAccountLogs = async (logQuery: IAccountLogQuery) => {
  const query = gql`
    query (
      $accountLogsId: String!
      $startDate: String!
      $endDate: String!
      $query: String
      $transactionType: AllowedTransactionType
      $userType: AllowedUserType!
    ) {
      accountLogs(
        id: $accountLogsId
        startDate: $startDate
        endDate: $endDate
        userType: $userType
        query: $query
        transactionType: $transactionType
      ) {
        data {
          name
          balance
          logs {
            id
            date
            transactionType
            warehouse
            invoice
            received
            user
            receivingBank
            runningBalance
          }
        }
        keywords
      }
    }
  `;

  const data = await client.request(query, logQuery);
  return data.accountLogs as { data: IAccountLogInfo; keywords: string };
};
